<template>
  <div :class="$style.container">
    <SettingsPagePanel>
      <NormalMessageChatReplyView />
    </SettingsPagePanel>
    <SettingsPagePanel>
      <AnswerMessageAutoChatReplyView />
    </SettingsPagePanel>
  </div>
</template>

<script setup lang="ts">
import SettingsPagePanel from '../SettingsPagePanel.vue'
import AnswerMessageAutoChatReplyView from './AnswerMessageAutoChatReplyView.vue'
import NormalMessageChatReplyView from './NormalMessageChatReplyView.vue'
</script>

<style lang="scss" module>
.container {
  display: flex;
  flex-direction: column;
  gap: 32px;
}
</style>
